import {FC, useEffect, useRef, useState} from 'react'
import {ScheduleCompletion} from './ScheduleCompletion'
import {useStore} from '../../store'
import {
  filterEventsBetween,
  getAllowableValues,
  getBusinessDay,
  getHoursOfOperationOnDay,
} from '../../helpers/generals'
import {addDays, addMinutes, eachMinuteOfInterval, format, startOfWeek} from 'date-fns'
import {KTSVG} from '../../../../../_fds/helpers'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

interface FdsModalProps {
  cancelButtonText: string
  saveButtonText: string
  saveButtonCallback: () => void
  closeButtonCallback: () => void
  titleText: string
  content: React.ReactNode
  show: boolean
  setShow: (show: boolean) => void
  size?: 'sm' | 'lg' | 'xl'
}

const FdsModal: FC<FdsModalProps> = ({
  cancelButtonText,
  saveButtonText,
  saveButtonCallback,
  closeButtonCallback,
  titleText,
  content,
  show,
  setShow,
  size,
}) => {
  // The modal stays mounted (and clickable) through its fade-out animation —
  // without this latch a double-click fires the save callback TWICE (e.g. a
  // workflow action posted twice: the second gets a 409). Reset when a modal
  // is (re)shown.
  const firedRef = useRef(false)
  useEffect(() => {
    if (show) {
      firedRef.current = false
    }
  }, [show])

  // Hide FIRST, then run the callback: callbacks may open a follow-up modal
  // (e.g. the workflow warning-acknowledge chain) via setSettings, and hiding
  // afterwards clobbered that new modal with the previous one's settings —
  // the follow-up never appeared.
  const handleClose = () => {
    if (firedRef.current) return
    firedRef.current = true
    setShow(false)
    closeButtonCallback()
  }
  const handleShow = () => setShow(true)
  const handleSave = () => {
    if (firedRef.current) return
    firedRef.current = true
    setShow(false)
    saveButtonCallback()
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} size={size}>
        <Modal.Header closeButton>
          <Modal.Title>{titleText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{content}</Modal.Body>
        <Modal.Footer>
          {cancelButtonText.length > 0 && (
            <Button variant='secondary' onClick={handleClose}>
              {cancelButtonText}
            </Button>
          )}
          {saveButtonText.length > 0 && (
            <Button variant='primary' onClick={handleSave}>
              {saveButtonText}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {FdsModal}
